import React, { useState } from 'react';
import { Form } from 'antd';
import { Button } from 'components/Atom/Button';
import Select from 'components/Atom/Select';
import DateRangePicker from 'components/Atom/DateRange';
import moment from 'moment';

const aggregationOptions = [
  { label: 'Count', value: 'count' },
  { label: 'Sum', value: 'sum' },
  { label: 'Latest', value: 'latest' },
  { label: 'Max', value: 'max' },
  { label: 'Fixed Retainer', value: 'fixed-retainer' },
];

const statusOptions = [
  { label: 'All', value: 'all' },
  { label: 'Active', value: 'true' },
  { label: 'Inactive', value: 'false' },
];

const Filter = ({ filtersData, handleClose, onSearch }) => {
  const [filterData, setFilterData] = useState(filtersData || {});

  const handleOnChangeValue = (value, type) => {
    if (type === 'date_range') {
      if (!value || value?.length === 0) {
        setFilterData((prev) => {
          const next = { ...prev };
          delete next[type];
          return next;
        });
      } else {
        setFilterData((prev) => ({ ...prev, [type]: value }));
      }
      return;
    }

    if (value === null || value === 'all') {
      setFilterData((prev) => {
        const next = { ...prev };
        delete next[type];
        return next;
      });
    } else {
      setFilterData((prev) => ({ ...prev, [type]: value }));
    }
  };

  const handleApplyFilters = () => {
    if (Object.keys(filterData ?? {})?.length > 0 || Object.keys(filtersData ?? {})?.length > 0) {
      onSearch(filterData);
      handleClose();
    } else {
      handleClose();
    }
  };

  return (
    <div style={{ width: '100%', marginTop: '1rem', marginBottom: '0.75rem' }}>
      <Form layout='vertical'>
        <div className='custom-child'>
          <div>
            <Form.Item label='Status' className='modalField font-bold'>
              <Select
                defaultValue={filtersData?.active ? statusOptions.find((item) => item.value === filtersData.active) : statusOptions[0]}
                optionsValue={statusOptions}
                value={filterData?.active ? statusOptions.find((item) => item.value === filterData.active) : statusOptions[0]}
                onChange={(e) => handleOnChangeValue(e?.value ?? e, 'active')}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item label='Aggregation Type' className='modalField font-bold'>
              <Select
                defaultValue={filtersData?.aggregation_type ? [...aggregationOptions].find((item) => item.value === filtersData.aggregation_type) : { label: 'All', value: 'all' }}
                optionsValue={[{ label: 'All', value: 'all' }, ...aggregationOptions]}
                value={filterData?.aggregation_type ? [...aggregationOptions].find((item) => item.value === filterData.aggregation_type) : { label: 'All', value: 'all' }}
                onChange={(e) => handleOnChangeValue(e?.value ?? e, 'aggregation_type')}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item className='modalField font-bold' label='Date Range'>
              <DateRangePicker
                defaultValue={filtersData?.date_range ? [moment(filtersData?.date_range[0]), moment(filtersData?.date_range[1])] : null}
                value={filterData?.date_range ?? null}
                hideButton={true}
                onChange={(e) => handleOnChangeValue(e, 'date_range')}
              />
            </Form.Item>
          </div>
        </div>
        <div className='binClass mt-1'>
          <div className='float-start filter-btn'>
            <Button onClick={handleApplyFilters}>Apply</Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Filter;
